import { axios, def, handleError } from './internal';

function AdminCfQueues(setData) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_cf_queues', {})
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, data: res.data.data, error: null });
            } else {
                setData((prev) => ({ ...prev, loading: false, error: res.data.message ?? 'Failed' }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false, error: err.message ?? 'Request failed' }));
            handleError(err);
        });
}

export { AdminCfQueues };
